import * as React from "react";
import { SortIcon } from "../../../../components/ui/icons";

const OrganizationUsersColumns = () => {
  return [
    {
      accessorFn: (row) => `${row.roleId}`,
      id: "roleType",
      header: (row) => (
        <div className="table-heading">
          Role Type{" "}
          <span>
            <SortIcon />
          </span>
        </div>
      ),
      cell: (info) => info.getValue(),
      footer: (props) => props.column.id,
    },
    {
      accessorFn: (row) => `${row.name}`,
      id: "userName",
      header: (row) => (
        <div className="table-heading">
          Name{" "}
          <span>
            <SortIcon />
          </span>
        </div>
      ),
      footer: (props) => props.column.id,
      enableColumnFilter: false,
      cell: (row) => <div className="table-cell">{row.getValue()}</div>,
    },
    {
      accessorFn: (row) => `${row?.groupId}`,
      accessorKey: "groupId",
      header: (row) => (
        <div className="table-heading">
          Groups{" "}
          <span>
            <SortIcon />
          </span>
        </div>
      ),
      footer: (props) => props.column.id,
      cell: (row) => <div className="table-cell">{row.getValue()}</div>,
    },
    {
      accessorFn: (row) => `${row.email}`,
      accessorKey: "email",
      header: (row) => (
        <div className="table-heading">
          Email{" "}
          <span>
            <SortIcon />
          </span>
        </div>
      ),
      footer: (props) => props.column.id,
      enableColumnFilter: false,
      cell: (row) => <div className="table-cell">{row.getValue()}</div>,
    },
  ];
};

export default OrganizationUsersColumns;
